module.exports = __webpack_public_path__ + "static/The_Dream_-_IV_Play_[Music_Video]-261-0b0f277594300c394afcfd980d4e4704.jpg";